// Animated screen exports use the original GIF frames and theme sprite timings.
const controllers = new Map();
const motion = matchMedia('(prefers-reduced-motion: reduce)');
function attach(viewer) {
  if (controllers.has(viewer)) return;
  const abort = new AbortController();
  let video, texture, visible = false;
  const playback = () => {
    if (!video) return;
    if (visible && !motion.matches && !document.hidden) video.play().catch(() => {});
    else video.pause();
  };
  const load = () => {
    if (texture || !viewer.model || !viewer.createVideoTexture) return;
    const material = viewer.model.materials.find(item => item.name === 'VibeTV Screen');
    if (!material) return;
    texture = viewer.createVideoTexture(viewer.dataset.screenVideo);
    video = texture.source.element;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.addEventListener('loadeddata', () => {
      material.pbrMetallicRoughness.setBaseColorFactor([0, 0, 0, 1]);
      material.pbrMetallicRoughness.setMetallicFactor(0);
      material.pbrMetallicRoughness.setRoughnessFactor(1);
      material.emissiveTexture.setTexture(texture);
      material.setEmissiveFactor([1, 1, 1]);
      playback();
    }, {signal: abort.signal, once: true});
    playback();
  };
  const observer = new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting;
    playback();
  });
  observer.observe(viewer);
  viewer.addEventListener('load', load, {signal: abort.signal});
  document.addEventListener('visibilitychange', playback, {signal: abort.signal});
  motion.addEventListener('change', playback, {signal: abort.signal});
  controllers.set(viewer, () => {
    abort.abort();
    observer.disconnect();
    if (video) {video.pause(); video.removeAttribute('src'); video.load();}
  });
  load();
}
function scan() {
  document.querySelectorAll('model-viewer[data-screen-video]').forEach(attach);
  for (const [viewer, dispose] of controllers) {
    if (!viewer.isConnected) {dispose(); controllers.delete(viewer);}
  }
}
await customElements.whenDefined('model-viewer');
scan();
new MutationObserver(scan).observe(document.body, {childList:true, subtree:true});
